import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: ",
        "px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { ActivityIndicator } from "@/components";
import styled from "styled-components";
const LoadingFragmentWrapper = styled.div.withConfig({
    componentId: "sc-cd291815-0"
})(_templateObject(), (param)=>{
    let { height  } = param;
    return height ? height : 480;
});
export const LoadingFragment = (param)=>{
    let { children , height  } = param;
    return /*#__PURE__*/ _jsxs(LoadingFragmentWrapper, {
        height: height,
        children: [
            /*#__PURE__*/ _jsx(ActivityIndicator, {}),
            children ? children : /*#__PURE__*/ _jsx("span", {
                style: {
                    marginLeft: 8
                },
                children: "Loading ..."
            })
        ]
    });
};
